import React, { useState, useMemo } from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Tag, Button, Input } from 'antd';
import { SearchOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { AdminSurveyListItemDto, SurveyType } from '@wellverse/shared-ts';

export const SurveyList: React.FC = () => {
  const navigate = useNavigate();
  const { tableProps } = useTable<AdminSurveyListItemDto>({
    resource: 'surveys',
    pagination: { current: 1, pageSize: 20 },
  });

  const [searchText, setSearchText] = useState('');

  const filteredData = useMemo(() => {
    if (!searchText) return tableProps.dataSource;
    const lower = searchText.toLowerCase();
    return tableProps.dataSource?.filter((item: any) =>
      item.name?.toLowerCase().includes(lower)
    );
  }, [tableProps.dataSource, searchText]);

  return (
    <List resource="surveys">
      <div style={{ marginBottom: 16 }}>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search by name..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 320 }}
          allowClear
        />
      </div>
      <Table {...tableProps} dataSource={filteredData} rowKey="id">
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column
          dataIndex="type"
          title="Type"
          filters={Object.values(SurveyType).map((t) => ({ text: t, value: t }))}
          onFilter={(value, record: any) => record.type === value}
        />
        <Table.Column dataIndex="version" title="Version" />
        <Table.Column
          dataIndex="isActive"
          title="Active"
          filters={[
            { text: 'Active', value: true },
            { text: 'Inactive', value: false },
          ]}
          onFilter={(value, record: any) => record.isActive === value}
          render={(isActive: boolean) => (
            <Tag
              style={{
                borderColor: isActive ? '#3ecf8e' : '#898989',
                color: isActive ? '#3ecf8e' : '#898989',
                background: isActive ? '#3ecf8e15' : '#89898915',
                borderRadius: 9999,
                padding: '2px 12px',
                fontWeight: 500,
              }}
            >
              {isActive ? 'Active' : 'Inactive'}
            </Tag>
          )}
        />
        <Table.Column dataIndex="screenCount" title="Screens" />
        <Table.Column
          dataIndex="createdAt"
          title="Created At"
          render={(date: string) => (date ? new Date(date).toLocaleString() : '—')}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_, record: AdminSurveyListItemDto) => (
            <Space>
              <Button
                size="small"
                icon={<AppstoreOutlined />}
                onClick={() => navigate(`/surveys/show/${record.id}`)}
              >
                Screens
              </Button>
              <EditButton hideText size="small" recordItemId={record.id} resource="surveys" />
              <ShowButton hideText size="small" recordItemId={record.id} resource="surveys" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="surveys" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
